import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';
import { getCustomerCreditCard } from 'redux/customerCreditCards/actions';

import EditRegularCreditCard from './editModal/EditRegularCreditCard';

const AddModal = (props) => {
  const { onCloseModal, cancelFunction, onEditCreditCard, creditCardId } =
    props;
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.setting).data;
  const customerCreditCardReducer = useSelector(
    (state) => state.customerCreditCard
  );

  useEffect(() => {
    dispatch(getCustomerCreditCard(creditCardId));
  }, [dispatch, creditCardId]);

  if (!settings || !customerCreditCardReducer.data) {
    return (
      <Modal title="Edit Credit Card" onCloseModal={onCloseModal}>
        &nbsp;
      </Modal>
    );
  }

  return (
    <EditRegularCreditCard
      onCloseModal={onCloseModal}
      cancelFunction={cancelFunction}
      onEditCreditCard={onEditCreditCard}
      creditCardId={creditCardId}
    />
  );
};

export default AddModal;

// import { Component } from 'react';
// import { connect } from 'react-redux';
// import { reduxForm } from 'redux-form';

// import { Modal, FormError } from 'common/components/layout';
// import { integerFormat } from 'common/helpers/numberHelper';
// import {
//   getCustomerCreditCard,
//   editCustomerCreditCard
// } from 'redux/customerCreditCards/actions';
// import { removeSpaces } from 'common/helpers/miscHelper';
// import { validateEdit } from './validators';
// import AddEditForm from './components/AddEditForm';

// class EditModal extends Component {
//   componentDidMount() {
//     const { props } = this;
//     const { creditCardId } = this.props;
//     props.getCustomerCreditCard(creditCardId);
//   }

//   handleSubmit = (form) => {
//     const { props } = this;
//     const { creditCardId } = this.props;
//     const data = transformData(form);
//     const successFunction = (creditCard) => {
//       props.onEditCreditCard(creditCard);
//     };
//     props.editCustomerCreditCard(creditCardId, data, successFunction);
//   };

//   render() {
//     const { settings, customerCreditCards } = this.props;
//     const { handleSubmit, object, form } = this.props;
//     const { onCloseModal, cancelFunction = onCloseModal } = this.props;

//     if (!settings.data || !customerCreditCards.data) {
//       return (
//         <Modal title="Edit Credit Card" onCloseModal={onCloseModal}>
//           &nbsp;
//         </Modal>
//       );
//     }
//     const cardsArr = Object.keys(customerCreditCards);
//     const isFirstCard = cardsArr.length === 1 || false;

//     return (
//       <Modal title="Edit Credit Card" onCloseModal={onCloseModal}>
//         <FormError formName={form} />
//         <AddEditForm
//           onSubmit={handleSubmit(this.handleSubmit)}
//           saveButtonText="Update Credit Card"
//           object={object}
//           showCreditEdit={false}
//           onCancelFunction={cancelFunction}
//           isFirstCard={isFirstCard}
//         />
//       </Modal>
//     );
//   }
// }

// const transformData = (values) => {
//   const data = {
//     cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
//     expiryMo: values.expiryMo && integerFormat(values.expiryMo),
//     expiryYr: values.expiryYr && integerFormat(values.expiryYr),
//     cvv2: values.cvv2,
//     cardHolderName: values.cardHolderName,
//     isDefault: values.isDefault
//   };
//   return data;
// };

// const validate = (values) => {
//   const data = transformData(values);
//   const errors = validateEdit(data);
//   return errors;
// };

// const mapStateToProps = (state, ownProps) => {
//   let formValues = {};
//   if (state.customerCreditCard.data) {
//     formValues = {
//       ...state.customerCreditCard.data[ownProps.creditCardId]
//     };
//     formValues.expiryMo = formValues.expiryMo && formValues.expiryMo.toString();
//     formValues.expiryYr = formValues.expiryYr && formValues.expiryYr.toString();
//   }
//   return {
//     initialValues: formValues,
//     object:
//       state.customerCreditCard.data &&
//       state.customerCreditCard.data[ownProps.creditCardId],
//     isFetching: state.customerCreditCard.isFetching,
//     settings: state.setting,
//     customerCreditCards: state.customerCreditCard
//   };
// };

// EditModal = reduxForm({
//   form: 'EditModal',
//   enableReinitialize: true,
//   onSubmitFail: (err, dispatch) => {
//     dispatch({ type: 'ADD_FORM_ERROR', payload: err });
//   },
//   onSubmitSuccess: (result, dispatch) => {
//     dispatch({ type: 'REMOVE_FORM_ERROR' });
//   },
//   validate
// })(EditModal);

// export default connect(mapStateToProps, {
//   getCustomerCreditCard,
//   editCustomerCreditCard
// })(EditModal);
